import React from "react";

class Loading extends React.Component {
    render() {
        return (
            <div>
                Loading...
            </div>
        )
    }
}

export default Loading;